import { useEffect } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import moment from "moment"

import { useUI } from "providers/UIProvider"

import { getHours, getMinutes, setHours, setMinutes } from "date-fns"
import { IAdminLaundryHoliday } from "types/laundry"
import { useAppContext } from "providers/AppProvider/AppProvider"

const ADMIN_HOLIDAY_FORM_INITIAL_VALUE = {
  carWashIds: Array<number>(),
  startDate: moment(new Date()).set({ hour: 9, minute: 0 }).toDate(),
  endDate: moment(new Date()).set({ hour: 20, minute: 0 }).toDate()
}

const ADD_HOLIDAY_SCHEMA = (t: any) => Yup.object({})

const useAdminHolidays = (laundryHolidayData: IAdminLaundryHoliday | null) => {
  const { toggleModal, T } = useUI()

  const { addAdminLaundryHoliday, updateLaundryHoliday, deleteLaundryHoliday, setAdminCurrentHoliday, selectedBranchesForHolidays } = useAppContext()
  const onSubmit = () => {
    if (laundryHolidayData) {
      updateLaundryHoliday({
        carWashId: laundryHolidayData.carWashId,
        id: laundryHolidayData.id,
        fromDateTime: values.startDate,
        toDateTime: values.endDate
      })
    } else {
      addAdminLaundryHoliday({ carWashIds: selectedBranchesForHolidays, fromDateTime: values.startDate, toDateTime: values.endDate })
    }
  }
  const { values, errors, touched, setValues, handleSubmit, resetForm } = useFormik({
    initialValues: ADMIN_HOLIDAY_FORM_INITIAL_VALUE,
    validationSchema: () => ADD_HOLIDAY_SCHEMA(T),
    onSubmit: onSubmit,
  })

  const handleTimeChange = (key: string, value: Date) => {
    const hours = getHours(value)
    const minutes = getMinutes(value)

    if (key === "startTime") {
      const updatedValues: any = {}
      const updatedDate = setHours(setMinutes(new Date(values.startDate), minutes), hours)
      updatedValues["startDate"] = updatedDate

      if (values.endDate < value) {
        updatedValues["endDate"] = setHours(setMinutes(new Date(values.endDate), minutes), hours)
      }

      setValues((currentValues) => ({ ...currentValues, ...updatedValues }))
    }

    if (key === "endTime") {
      const updatedDate = setHours(setMinutes(new Date(values.endDate), minutes), hours)
      setValues((currentValues) => ({ ...currentValues, endDate: updatedDate }))
    }
  }

  const handleDateChange = (key: string, value: Date) => {
    const updatedValues: any = { ...values }

    updatedValues[key] = value

    updatedValues["carWashIds"] = selectedBranchesForHolidays;

    // if (key === "startDate") {
    //   updatedValues["endDate"] = value
    // }

    setValues((currentValues) => ({ ...currentValues, ...updatedValues }))
  }

  const handleAddAdminEditClick = (adminHoliday: IAdminLaundryHoliday | null) => {
    toggleModal("addAdminEditHolidayModal", true, adminHoliday)
    setAdminCurrentHoliday(adminHoliday)
  }

    const handleDeleteClick = (holilday: IAdminLaundryHoliday) => {
      toggleModal("confirmationModal", true, {
        title: T("holiday.delete_holiday_confirm"), 
        handleSubmit: () => deleteLaundryHoliday(holilday.id)
      })
    }

  useEffect(() => {
    if (laundryHolidayData) {
      setValues({carWashIds: [laundryHolidayData.carWashId], startDate: new Date(laundryHolidayData.fromDateTime), endDate: new Date(laundryHolidayData.toDateTime) })
    }
  }, [laundryHolidayData])

  return {
    handleTimeChange,
    handleDateChange,
    handleAddAdminEditClick,
    handleDeleteClick,
    selectedBranchesForHolidays,
    form: {
      values,
      errors,
      touched,
      setValues,
      handleSubmit,
      resetForm
    },
  }
}

export default useAdminHolidays
